import { Component, OnChanges, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InternalLocationservice } from '../../services/internallocation.service';
import { LocationService } from '../../services/location.service';
import { Methods } from '../../shared/methods';
import swal from 'sweetalert2';

import { TicketsService } from '../../services/tickets.service';
import { Ticket } from '../../models/ticket';
import { ChatLogService } from '../../services/chatlog.service';
import { ChatLog } from '../../models/chatLog';
import { ScrapService } from '../../services/scrap.service';
import { WeightItemService } from '../../services/weightitem.service';
import { TaggingGroupService } from '../../services/tagginggroup.service';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { UserService } from '../../services/user.service';
import { ProcessingpService } from "../../services/processing.service";
import { Status } from '../../pipes/status.pipe';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: any[][];
}

declare const $: any;

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css'],
  providers: [UserService, LocationService, ScrapService, ChatLogService, TaggingGroupService]
})
export class TicketsComponent implements OnChanges, AfterViewInit {

  public aplicarTodos = true;
  public searchItem = '';
  public itemsSeleccionados = [];
  public to = 'USERS';
  public mensaje = '';
  public toppingList: any[] = [];
  public repsList: any[] = [];
  public taggingList: any[] = [];
  public groupsList: any[] = [
    { id: 'ADMINISTRATOR', name: 'ADMINISTRATOR', surname: '' },
    { id: 'CLERICALREP', name: 'CLERICALREP', surname: '' },
    { id: 'customer', name: 'CUSTOMER', surname: '' },
    { id: 'DRIVER', name: 'DRIVER', surname: '' },
    { id: 'MANAGER', name: 'MANAGER', surname: '' },
    { id: 'PURCHASINGREP', name: 'PURCHASINGREP', surname: '' },
    { id: 'RECEIVINGDEPARTMENT', name: 'RECEIVINGDEPARTMENT', surname: '' },
    { id: 'MANIFESTDEPARTMENT', name: 'MANIFESTDEPARTMENT', surname: '' },
    { id: 'SALESREP', name: 'SALESREP', surname: '' },
    { id: 'SHIPPINGREP', name: 'SHIPPINGREP', surname: '' },
    { id: 'TECHREP', name: 'TECHREP', surname: '' },
    { id: 'VENDOR', name: 'VENDOR', surname: '' },
    { id: 'WAREHOUSEREP', name: 'WAREHOUSEREP', surname: '' }
  ];

  myWebSocket: WebSocketSubject<any> = webSocket('wss://www.greenteksolutions.com/myws');
  public numberNotifications;
  public notificationsData;
  public chats: Array<ChatLog>;

  public mtds: Methods = new Methods();

  @Output() changeLocations: EventEmitter<any>;

  @Input() po_id: number;
  @Input() po_number: number;
  @Input() weigths_number: number;
  @Input() pi_id: number;
  @Input() whs_id: number;
  public index = true;
  public loading = false;
  public loadingItems = false;
  public saving = false;
  public token;
  public identity;
  public globalLocation = null;
  public edit = false;
  public recibiendo = false;
  public tableData: DataTable;
  public newchatmsg;
  public hideprocessed = 1;
  public showWarehouseError:boolean = false;

  public ticket: Ticket = new Ticket();
  public askdpts: any[] = [];

  public items: any[] = [];
  public itemsManifest: any[] = [];
  public scraps: any[] = [];
  public recibiendoItems: any[] = [];
  public recibiendoManifest: any[] = [];
  public recibiendoScraps: any[] = [];
  public bulkItems: number[] = [];
  public bulkItemsManifest: number[] = [];
  public bulkScraps: number[] = [];
  public bulkReceived: number[] = [];
  public bulkReceivedManifest: number[] = [];
  public bulkReceivedScraps: number[] = [];
  public deadline = 'ASAP';

  public jsonChatLog;

  public viendoComentarios = false;

  public idChat;
  public itemChat;
  public typeChat;

  constructor(
    private _router: Router,
    private _scrapService: ScrapService,
    private _route: ActivatedRoute,
    private _ticketsService: TicketsService,
    private _intertnalLocationService: InternalLocationservice,
    private _locationService: LocationService,
    private _weightItemService: WeightItemService,
    private _chatLogService: ChatLogService,
    private _taggingService: TaggingGroupService,
    private _processingpService: ProcessingpService,
    private _userService: UserService) {
    this.changeLocations = new EventEmitter;
    this.token = JSON.parse(localStorage.getItem('token'));
    this.identity = JSON.parse(localStorage.getItem('identity'));
    this.ticket.po = this.po_id;
    this.ticket.rep = this.identity.sub;
    this.tableData = {
      headerRow: [
        'Id',
        'type',
        'Status.',
        'Items Completed',
        'Date',
        'Comments'
      ],
      footerRow: [],
      dataRows: []
    };   

    this._userService.getAllUsersLite(this._userService.getToken(), 'workers').subscribe(
      response => {
        console.log("respuesta users tickets");
        if (response.status === 'success') {
          console.log(response);
          this.repsList = response.data;
          this.toppingList = this.repsList;
          console.log(this.toppingList);
        } else {
          alert('Error');
        }
      },
      error => {
        console.log(<any>error);
        alert('Error');
      }
    );

    this._taggingService.listByUser(this.token, this.identity.sub).subscribe(
      response =>{
        if(response.status == 'success'){

          let element;

          for (element of response.data) {

            this.taggingList.push(
              {
                id: element.name, 
                name: element.name, 
                surname: ''
              }
            );
          }

        }else{
          alert('Error');
        }
      },
      error => {
        console.log(<any>error);
        alert('Error');
      }
    ); 
  }

  ngOnChanges(changes) {
    if (changes['po_id']) {
      this.getAll();      
      console.log(this.po_id);
      console.log(this.pi_id);

      let json = {
        type: 'po',
        po:   this.po_id     
      }

      this._intertnalLocationService.getAvailablesForTicketNew(json).subscribe(
        response => {
          console.log(response);
          this.askdpts = response.data;
        }
      );

      this._route.params.subscribe(params => {
        if (params['ticket']) {
          let e = {
            evento: 'show',
            id: params['ticket']
          }

          this.action(e);
          history.pushState(null, "", "processing-instructions");
        }
      });
    }
  }

  async ocultarProcesados(e) {
    console.log(e);
    await this.changeHide(e.checked)
    await this.getItems();
    await this.getScraps();
    await this.getItemsManifest();
  }

  changeHide(e) {
    if (e) {
      this.hideprocessed = 1;
    } else {
      this.hideprocessed = 0;
    }
    this.bulkItems = [];
    this.bulkScraps = [];
    this.bulkItemsManifest = [];
  }

  ngAfterViewInit() {

  }

  public editCommentsId = null;
  public editCommentsIdx = null;
  public saingComments = false;
  public comentarios = '';

  viewItemComments(item) {
    this.bulkItems = [];
    this.bulkScraps = [];
    console.log(item);
    this.viendoComentarios = true;
    this.editCommentsId = item.id;
    this.editCommentsIdx = item.idx;
    this.comentarios = item.comments;
    console.log(this.editCommentsIdx);

    if(typeof item.categoryId !== 'undefined'){
         this.jsonChatLog = {
        type: 'TICKETSCRAPINDEX'
      }
    } else {
      this.jsonChatLog = {
        type: 'TICKETINDEX'
      }
    }

    

    this.getChat();
  }

  viewManifestItemComments(item){
    this.bulkItemsManifest = [];

     this.viendoComentarios = true;
    this.editCommentsId = item.id;
    this.editCommentsIdx = item.idx;
    this.comentarios = item.comments;

  
      this.jsonChatLog = {
        type: "TICKETMANIFESTNDEX",
      };

      this.getChat();
  
  }

  cancelEditComments() {
    this.viendoComentarios = false;
    this.saingComments = false;
    this.comentarios = '';
    this.editCommentsIdx = null;
    this.editCommentsId = null;
  }

  updateComments() {
    let json = {
      comments: this.comentarios
    };

    this.saingComments = true;

    this._ticketsService.editComments(this.editCommentsIdx, json).subscribe(
      response => {
        console.log(response);
        this.saingComments = false;
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.cancelEditComments();
          this.getindexes(this.ticket.id);
          this.getindexesManifest(this.ticket.id);
          this.getScrapindexes(this.ticket.id);
          this.mtds.notifySuccess('Comments has been updated successfully');
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      }, error => {
        this.saingComments = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getAll() {
    this.loading = true;
    this.tableData.dataRows = [];
    this._ticketsService.getByPO(this.po_id).subscribe(
      response => {
        let element;
        console.log(response);
        this.tableData.dataRows = [];
        for (element of response.data) {
          let row = [
            element.id,
            element.type,
            element.status,
            element.createdAt,
            element.numItemsCompleted,
            element.numItems,
            element.askedLocation !== null ? element.askedLocation.locationName : '',
            element.rep.name + " " + element.rep.surname,
            element.deadline,
            element.toUsersData
          ];
          this.tableData.dataRows.push(row);
        }
        this.loading = false;
      }
    );
  }

  changeDeadline() {
    if (this.deadline !== 'Custom') {
      this.ticket.deadline = this.deadline;
    } else {
      this.ticket.deadline = this.mtds.getFecha(new Date());
    }
  }

  public requesetdBy = '';

  action(e) {
    console.log(e);

    switch (e.evento) {
      case 'create':
        $(".noticket").hide();
        this.edit = true;
        this.index = false;
        this.ticket.po = this.po_id;
        this.ticket.rep = this.identity.sub;
        this.getItems();
        this.getScraps();
        this.getItemsManifest();
        break;
      case 'show':
        this.loading = true;
        $(".noticket").hide();
        this._ticketsService.getOne(e.id).subscribe(
          response => {
            console.log(response);
            if (response.status === 'success') {
              this.ticket = new Ticket(
                response.data.id,
                response.data.po.id,
                response.data.rep.id,
                response.data.type,
                response.data.status,
                response.data.numItemsCompleted,
                response.data.comments,
                response.data.askedLocation !== null ? response.data.askedLocation.id : null,
                response.data.deadline
              );
              this.requesetdBy = response.data.rep.name + ' ' + response.data.rep.surname;
              if (this.ticket.deadline === 'ASAP' || this.ticket.deadline === 'Today no rush' || this.ticket.deadline === 'Tomorrow') {
                this.deadline = this.ticket.deadline;
              } else {
                this.deadline = 'Custom';
              }
              this.loading = false;
              this.index = false;
              this.getindexes(e.id);
              this.getScrapindexes(e.id);
              this.getindexesManifest(e.id);
            } else {
              this.mtds.notifyError(response.msg, response.code);
              this.cancel();
            }
          }, error => {
            this.mtds.notifyError(error.statusText, error.status);
            this.cancel();
          }
        );
        break;
      case 'delete':

        swal.fire({
          title: 'Remove Ticket',
          text: 'Are you sure to delete this Ticket?',
   
          showCancelButton: true,
          buttonsStyling: false,
        
          customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },

          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Continue',
        }).then(function (result) {
          if (result.value) {
            this._ticketsService.delete(e.id).subscribe(
              response => {  
                console.log(response);
                if (response.status === 'success') {
                  this.myWebSocket.next({
                    'notify': '1',
                    'data': this.pi_id,
                    'type': 'TICKETCANCELLED',
                    'token': this.token,
                    'action': 'DELETE', // NEW ó UPDATE ó DELETE
                    'toDestiny': 'USERS',
                    'toData': response.usersToSend,
                    'element': e.id,
                    'texto': this.po_number
                  });
  
                  this.myWebSocket.asObservable().subscribe(
                    msg => {
                      let msgCoded;
                      msgCoded = JSON.stringify(msg);
                      console.log('message received: ' + msgCoded);
                      this.numberNotifications = msg.numberNotifications;
                      this.notificationsData = msg.data;
                    },
                    // Called whenever there is a message from the server
                    err => console.log(err),
                    // Called if WebSocket API signals some kind of error
                    () => console.log('complete')
                    // Called when connection is closed (for whatever reason)
                  );
  
                  this.getAll();
                  swal.fire({
               
                    title: 'Ticket has been removed successfully',
                    text: '',
                    buttonsStyling: false,
                
                    customClass:{
    confirmButton: 'btn btn-success'
            },
                  });
                } else {
                  this.mtds.notifyError(response.msg, response.code);
                }
              }, error => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
          }
        }.bind(this));

        break;
      default:
        break;
    }
  }

  procesar() {
    swal.fire({
      title: 'Mark as Processed',
      text: 'Only items with "Received" status will be processed',
    
      showCancelButton: true,
      buttonsStyling: false,
      customClass:{
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-default',
            },
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Continue',
    }).then(function (result) {
      if (result.value) {
        let item, bulk = [];
        for (item of this.items) {
          let i;
          for (let i of this.bulkItems) {
            if (i === item.id && item.status === 'received') {
              bulk.push(item.idx);
            }
          }
        }
        let json = {
          bulk: bulk
        };
        this._ticketsService.bulkstatus(json).subscribe(
          response => {
            console.log(response);
            this.ticket.status = response.data.status;
            this.getindexes(this.ticket.id);
            this.getScrapindexes(this.ticket.id);
          }, error => {
            this.mtds.notifyError(error.statusText, error.status);
          }
        );
      }
    }.bind(this));
  }

  checkPending() {
    let karol: boolean = true;
    for(let item of this.items) {
      let i;
      for (let i of this.bulkItems) {
        if (i === item.id && item.status === 'pending') {
          karol =  false;
          break;
        }
      }
      if (!karol) { break; }
    }

    for (let item of this.itemsManifest) {
      let i;
      for (let i of this.bulkItemsManifest) {
        if (i === item.id && item.status === "pending") {
          karol = false;
          break;
        }
      }
      if (!karol) {
        break;
      }
    }

    for(let scrap of this.scraps) {
      let i;
      for (let i of this.bulkScraps) {
        if (i === scrap.id && scrap.status === 'pending') {
          karol =  false;
          break;
        }
      }
      if (!karol) { break; }
    }
    return karol;
  }

  async recibir() {
    this.loading = true;
    this.recibiendo = true;
    this.recibiendoItems = [];
    this.recibiendoScraps = [];
    this.recibiendoManifest = [];

    for (let item of this.items) {
      for (let i of this.bulkItems) {
        if (i === item.id && item.status === 'pending') {

          this.getAvailaleLocations(item);
        }
      }
      console.log(this.recibiendoItems);
    }

    for (let item of this.itemsManifest) {
      for (let i of this.bulkItemsManifest) {
        if (i === item.id && item.status === "pending") {
          this.getAvailaleLocationsManifest(item);
        }
      }
      console.log(this.recibiendoManifest);
    }

    for (let item of this.scraps) {
      for (let i of this.bulkScraps) {
        if (i === item.id && item.status === 'pending') {

          this.getAvailaleLocationsScraps(item);
        }
      }
      console.log(this.recibiendoScraps);
    }
    await this.loadingFalse();
    // this.selectAll();
  }

  loadingFalse() {
    this.loading = false;
  }

  getAvailaleLocationsScraps(scrap) {
    this.loading = true;
    let json = {
      item: scrap.item,
      totalNetWeight: scrap.tareWeight
    };
    this._locationService.getAvailables(this.token, this.whs_id, json).subscribe(
      response => {
        console.log(response);
        if (response.status === 'success') {
          let element = {
            id: scrap.id,
            idx: scrap.idx,
            status: scrap.status,
            item: scrap.item,

            fechaCreado: scrap.fechaCreado,
            categoryId: scrap.categoryId,
            tareWeight: scrap.tareWeight,
            fechaModificado: scrap.fechaModificado,

            internalLocation_id: scrap.internalLocation !== null ? scrap.internalLocation.id : null,
            availableLocations: response.data
          }
          this.recibiendoScraps.push(element);
        } else {
        this.showWarehouseError = true;
        }
        this.loading = false;
      },
      error => {
        console.log(<any>error);
        this.loading = false;
      }
    );
  }

  getAvailaleLocations(item) {
    this.loading = true;
    let json = {
      item: item.item,
      totalNetWeight: item.weight
    };
    this._locationService.getAvailables(this.token, this.whs_id, json).subscribe(
      response => {
        console.log(response);
        if (response.status === 'success') {
          let weight = {
            id: item.id,
            idx: item.idx,
            status: item.status,
            item: item.item,
            pending: item.pending,
            weight: item.weight,
            damages: item.damages,
            createdAt: item.createdAt,
            internalLocation_id: item.internalLocation !== null ? item.internalLocation.id : null,
            availableLocations: response.data
          }
          this.recibiendoItems.push(weight);
        }else {
        this.showWarehouseError = true;
        }
        this.loading = false;
      },
      error => {
        console.log(<any>error);
        this.loading = false;
      }
    );
  }


  getAvailaleLocationsManifest(item) {
    this.loading = true;
    let json = {
      item: item.typeOfContent,
      totalNetWeight: item.weight
    };
    this._locationService.getAvailables(this.token, this.whs_id, json).subscribe(
      response => {
        console.log(response);
        if (response.status === 'success') {
          let weight = {
            id: item.id,
            idx: item.idx,
            status: item.status,
            item: item.item,
            pending: item.pending,
            containerType: item.containerType,
            typeOfContent: item.typeOfContent,
            weight: item.weight,
            createdAt: item.createdAt,
            internalLocation_id: item.internalLocation !== null ? item.internalLocation.id : null,
            availableLocations: response.data
          }
          this.recibiendoManifest.push(weight);
        }else {
        this.showWarehouseError = true;
        }
        this.loading = false;
      },
      error => {
        console.log(<any>error);
        this.loading = false;
      }
    );
  }



  async saveRecibir() {
    this.saving = true;
    let item;
    for (item of this.recibiendoItems) {
      this.bulkReceived.push(item.idx);
    }
    for (item of this.recibiendoScraps) {
      this.bulkReceivedScraps.push(item.idx);
    }

    for (item of this.recibiendoManifest) {
      this.bulkReceivedManifest.push(item.idx);
    }

    let json = {
      bulk: this.bulkReceived,
      bulkScrap: this.bulkReceivedScraps,
      bulkManifest: this.bulkReceivedManifest
    }
    let valor = await this.aplicar();
    console.log(valor);
    console.log('Ya salimos');
    
  }


  finishRecibir(){

    let json = {
      bulk: this.bulkReceived,
      bulkScrap: this.bulkReceivedScraps,
      bulkManifest: this.bulkReceivedManifest
    }

    this._ticketsService.bulkReceived(json).subscribe(
      response => {
        console.log(response);
        console.log('Entramos a bulk Received');
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {

          if (typeof response.usersTosend != 'undefined') {



            this.myWebSocket.next({
              'notify': '1',
              'data': this.pi_id,
              'type': 'TICKETPROCESSED',
              'token': this.token,
              'action': 'UPDATE', // NEW ó UPDATE ó DELETE
              'toDestiny': 'USERS',
              'toData': JSON.stringify(response.usersTosend),
              'element': response.data.id,
              'texto': this.po_number
            });

            this.myWebSocket.asObservable().subscribe(
              msg => {
                let msgCoded;
                msgCoded = JSON.stringify(msg);
                console.log('message received: ' + msgCoded);
                this.numberNotifications = msg.numberNotifications;
                this.notificationsData = msg.data;
              },
              // Called whenever there is a message from the server
              err => console.log(err),
              // Called if WebSocket API signals some kind of error
              () => console.log('complete')
              // Called when connection is closed (for whatever reason)
            );
          }

          this.cancelarRecibir();
          this.mtds.notifySuccess('Items were satisfactorily received');
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.saving = false;
      }, error => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  cancelarRecibir() {
    this.recibiendo = false;
    this.recibiendoItems = [];
    this.recibiendoScraps = [];
    this.recibiendoManifest = [];
    this.bulkReceived = [];
    this.bulkReceivedScraps = [];
    this.bulkReceivedManifest = [];
    this.bulkItems = [];
    this.bulkItemsManifest = [];
    this.bulkScraps = [];
    this.getindexes(this.ticket.id);
    this.getScrapindexes(this.ticket.id);
    this.getindexesManifest(this.ticket.id);

    this.loading = true;
    this._ticketsService.getOne(this.ticket.id).subscribe(
      response => {
        console.log(response);
        this.ticket = new Ticket(
          response.data.id,
          response.data.po.id,
          response.data.rep.id,
          response.data.type,
          response.data.status,
          response.data.numItemsCompleted,
          response.data.comments,
          response.data.askedLocation !== null ? response.data.askedLocation.id : null,
          response.data.deadline
        );
        if (this.ticket.deadline === 'ASAP' || this.ticket.deadline === 'Today no rush' || this.ticket.deadline === 'Tomorrow') {
          this.deadline = this.ticket.deadline;
        } else {
          this.deadline = 'Custom';
        }
        this.loading = false;
        this.index = false;
      }
    );

  }

  checkReceived() {
    let item;
    for (item of this.items) {
      let i;
      for (let i of this.bulkItems) {
        if (i === item.id && item.status === 'received') {
          return false;
        }
      }
    }
    return true;
  }

  getindexes(ticket_id) {
    this.loadingItems = true;
    this.items = [];
    this._ticketsService.indexesdetail(ticket_id).subscribe(
      response => {
        console.log(response);
        let item;
        for (item of response.data) {
          let idx = {
            id: item.weight.id,
            idx: item.id,
            status: item.status,
            item: item.weight.item,
            pending: item.weight.pending,
            weight: item.weight.weight,
            damages: item.weight.damages,
            createdAt: item.weight.createdAt,
            internalLocation: item.weight.internalLocation,
            from: item.fromLocation !== null ? item.fromLocation.locationName + ': ' + item.fromLocation.locationRow + ' - ' +
              item.fromLocation.locationBay + ' - ' + item.fromLocation.locationLevel + ' - ' + item.fromLocation.locationSection : '',
            comments: item.comments,
            destination: item.destinationLocation !== null ? item.destinationLocation.locationName + ': ' + item.destinationLocation.locationRow + ' - ' +
            item.destinationLocation.locationBay + ' - ' + item.destinationLocation.locationLevel + ' - ' + item.destinationLocation.locationSection : '',

          };
          console.log(idx);
          this.items.push(idx);
        }
        this.loadingItems = false;
      }
    );
  }

  getindexesManifest(ticket_id) {
    console.log(ticket_id);
    this.loadingItems = true;
    this.itemsManifest = [];
    this._ticketsService.indexesmanifestdetail(ticket_id).subscribe((response) => {
      console.log("indexesmanifestdetail => ", response);
      let item;
      for (item of response.data) {
        let idx = {
          id: item.manifestItem.id,
          idx: item.id,
          status: item.status,
          batch: item.manifestItem.batch,
          containerType: item.manifestItem.containerType,
          typeOfContent: item.manifestItem.typeOfContent,
          item: item.manifestItem.containerType + ' ' + item.manifestItem.typeOfContent,
          pending: item.manifestItem.pending,
          weight: item.manifestItem.weight,
          damages: 'no',
          po: item.manifestItem.processingInstruction.po.po,
          createdAt: item.manifestItem.createdAt,
          internalLocation: item.manifestItem.internalLocation,
          from:
            item.fromLocation !== null
              ? item.fromLocation.locationName +
                ": " +
                item.fromLocation.locationRow +
                " - " +
                item.fromLocation.locationBay +
                " - " +
                item.fromLocation.locationLevel +
                " - " +
                item.fromLocation.locationSection
              : "",
          comments: item.comments,
          numchats: item.numchats,
          destination:
            item.destinationLocation !== null
              ? item.destinationLocation.locationName +
                ": " +
                item.destinationLocation.locationRow +
                " - " +
                item.destinationLocation.locationBay +
                " - " +
                item.destinationLocation.locationLevel +
                " - " +
                item.destinationLocation.locationSection
              : "",
        };
        console.log(idx);
        this.itemsManifest.push(idx);
      }
      this.loadingItems = false;
    });
  }

  getScrapindexes(ticket_id) {
    this.loadingScraps = true;
    this.scraps = [];
    this._ticketsService.indexesscrap(ticket_id).subscribe(
      response => {
        console.log(response);
        let item;
        for(item of response.data) {
          let idx = {
            id: item.scrap.id,
            idx: item.id,
            status: item.status,
            item: item.scrap.item,
            fechaCreado: item.scrap.fechaCreado,
            categoryId: item.scrap.categoryId,
            tareWeight: item.scrap.tareWeight,
            fechaModificado: item.scrap.fechaModificado,
            internalLocation: item.scrap.internalLocation,
            from: item.fromLocation !== null ? item.fromLocation.locationName + ': ' + item.fromLocation.locationRow + ' - ' +
            item.fromLocation.locationBay + ' - ' + item.fromLocation.locationLevel + ' - ' + item.fromLocation.locationSection : '',
            destination: item.destinationLocation !== null ? item.destinationLocation.locationName + ': ' + item.destinationLocation.locationRow + ' - ' +
            item.destinationLocation.locationBay + ' - ' + item.destinationLocation.locationLevel + ' - ' + item.destinationLocation.locationSection : '',

          };
          console.log(idx);
          this.scraps.push(idx);
        }
        this.loadingScraps = false;
      }
    );
  }

  getItems() {
    this.loadingItems = true;
    this._weightItemService.getItemsAvailablesByFather(this.token, this.po_id, this.hideprocessed).subscribe(
      response => {
        console.log(response);
        this.items = response.data;
        this.loadingItems = false;
      }
    );
  }

  getItemsManifest() {
    this.loadingItems = true;
    this._processingpService
      .getItemsAvailablesByFather(
        this.token,
        this.ticket.po,
        this.hideprocessed
      )
      .subscribe((response) => {
        console.log(response);
        this.itemsManifest = response.data;
        this.loadingItems = false;
      });
  }

  public loadingScraps: boolean = false;

  getScraps() {
    this._scrapService.getScrapsByFather(this.token, this.po_id, this.hideprocessed).subscribe(
      response => {
        console.log(response);
        this.scraps = response.data;
      }
    );
  }

  cancel() {
    this.index = true;
    this.ticket = new Ticket();
    this.ticket.po = this.po_id;
    this.ticket.rep = this.identity.sub;
    this.deadline = 'ASAP';
    this.edit = false;
    this.items = [];
    this.scraps = [];
    this.bulkItems = [];
    this.bulkScraps = [];
    this.requesetdBy = '';
    $(".noticket").show();
    this.getAll();
    this.reset();
  }

  send() {
    this.saving = true;
    let json, i;
    json = {
      type: 'NEWTICKET',
      toDestiny: this.to,
      toData: this.itemsSeleccionados,
      texto: this.mensaje
    };
    this.ticket.indexes = [];
    this.ticket.indexesScrap = [];
    this.ticket.indexesManifest = [];
    for (i of this.bulkItems) {
      let idx = {
        weight: i,
        status: 'pending',
        comments: ''
      }
      this.ticket.indexes.push(idx);
    }

    for (let i of this.bulkItemsManifest) {
      let idx = {
        weight: i,
        status: "pending",
        comments: "",
      };
      this.ticket.indexesManifest.push(idx);
    }

    for (let i of this.bulkScraps) {
      let idx = {
        scrap: i,
        status: 'pending',
        comments: ''
      }
      this.ticket.indexesScrap.push(idx);
    }
    this.ticket.notificacion = json;
    this._ticketsService.create(this.ticket).subscribe(
      response => {
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.bulkItems = [];
          this.bulkScraps = [];
          this.myWebSocket.next({
            'notify': '1',
            'data': this.pi_id,
            'type': 'NEWTICKET',
            'token': this.token,
            'action': 'NEW', // NEW ó UPDATE ó DELETE
            'toDestiny': this.to,
            'toData': this.itemsSeleccionados,
            'element': this.ticket.id,
            'texto': this.po_number + ' - ' + this.ticket.deadline
          });

          this.myWebSocket.asObservable().subscribe(
            msg => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log('message received: ' + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            err => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log('complete')
            // Called when connection is closed (for whatever reason)
          );

          this.mtds.notifySuccess('A new ticket has been created');
          this.cancel();
          this.getAll();
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.saving = false;
      }, error => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  buscarItem(name, surname) {
    let item = name.toUpperCase() + ' ' + surname.toUpperCase();
    if (this.searchItem !== '' && (item.includes(this.searchItem.toUpperCase()))) { return true; }

    return false;
  }

  reset() {
    this.itemsSeleccionados = [];
    this.searchItem = '';
    if (this.to === 'USERS') {
      this.toppingList = this.repsList;
    } else if (this.to === 'GROUPS') {
      this.toppingList = this.groupsList;
    } else {
      this.toppingList = this.taggingList;
    }
  }

  seleccionar(id) {
    let numero: number, encontrado: boolean, index: number;
    index = 0;
    encontrado = false;
    for (numero of this.itemsSeleccionados) {
      if (numero === id) {
        encontrado = true;
        this.itemsSeleccionados.splice(index, 1);
        break;
      }
      index++;
    }

    if (!encontrado) {
      this.itemsSeleccionados.push(id);
    }

    this.searchItem = "";
  }

  chequeado(id) {
    let numero: number;
    for (numero of this.itemsSeleccionados) {
      if (numero === id) {
        return true;
      }
    }

    return false;
  }

  checkAll() {
    let item;
    for (item of this.recibiendoItems) {
      if (!this.check(item.id)) {
        return false;
      }
    }
    return true;
  }

  check(id) {
    let i;
    for (i of this.bulkReceived) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  checkManifest(id) {
    let i;
    for (i of this.bulkReceivedManifest) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  selectAll(change: boolean = false) {
    if (change) {
      this.aplicarTodos = !this.aplicarTodos;
    }

    if (this.globalLocation !== null && this.aplicarTodos) {
      let item;
      for (item of this.recibiendoItems) {
        item.internalLocation_id = this.globalLocation;
      }
    }

  }

  selectItem(id) {
    let i, find = false;
    for (i = 0; i < this.bulkReceived.length; i++) {
      if (this.bulkReceived[i] === id) {
        this.bulkReceived.splice(i, 1);
        find = true;
        break;
      }
    }

    if (!find) {
      this.bulkReceived.push(id);
    }
  }

  selectItemManifest(id) {
    let i,
      find = false;
    for (i = 0; i < this.bulkReceivedManifest.length; i++) {
      if (this.bulkReceivedManifest[i] === id) {
        this.bulkReceivedManifest.splice(i, 1);
        find = true;
        break;
      }
    }

    if (!find) {
      this.bulkReceivedManifest.push(id);
    }
  }

  public cambiandoLocaciones = false;

  aplicar() {

    let me = this;
    console.log('Entramos a aplicar');
    this.cambiandoLocaciones = true;
    let item, bulkLocations = [];
    for (item of this.recibiendoItems) {
      let loc = {
        idweight: item.id,
        idlocation: item.internalLocation_id
      }
      bulkLocations.push(loc);
    }

    for (item of this.recibiendoManifest) {
      let loc = {
        idmanifest: item.id,
        idlocation: item.internalLocation_id,
      };
      bulkLocations.push(loc);
    }

    for (item of this.recibiendoScraps) {
      let loc = {
        idscrap: item.id,
        idlocation: item.internalLocation_id
      }
      bulkLocations.push(loc);
    }

    let json = {
      'data': bulkLocations,
      'isticket': true
    }

    return this._ticketsService.bulkLocations(json).subscribe(
      response => {
        console.log(response);

        this.cancelarRecibir();

      /*  let objeto = {
          numInmanifest: response.data.numInmanifest,
          numInsales: response.data.numInsales,
          numIntesting: response.data.numIntesting,
          numReceived: response.data.numReceived,
          num_processed: response.data.numProcessed,
          num_inmanifest_second: response.data.numInmanifestSecond,
          num_insales_second: response.data.numInsalesSecond,
          num_intesting_second: response.data.numIntestingSecond,
          num_received_second: response.data.numReceivedSecond,
          num_processed_second: response.data.numProcessedSecond,
          beenInmanifest: response.data.beenInmanifest,
          beenInsales: response.data.beenInsales,
          beenIntesting: response.data.beenIntesting,
          beenReceived: response.data.beenReceived
        }
*/
       // this.changeLocations.emit(objeto);

        this.cambiandoLocaciones = false;
        //me.finishRecibir();
      }
    );
  }

  nolocation() {
    let item;
    for (item of this.recibiendoItems) {
      if (item.internalLocation_id === null || item.internalLocation_id === '') {
        return false;
      }
    }

    return true;
  }

  cambiar(e, item) {
    console.log(item);
    console.log(e);
    if (item.internalLocation_id !== e) {
      item.internalLocation_id = e;
      // this.cambiarLocacion(item);
    }
  }

  getChat() {
  




    this._chatLogService.getChat(this.token, this.editCommentsIdx,  this.jsonChatLog).subscribe(
      response => {
        if (response.status === 'success') {
          this.chats = response.data;
          //console.log(this.chats);
        }
      },
      error => {
        console.log(<any>error);
      }
    );

  }

  sendMessage(message: string) {
    message = message.trim();
    if (message.length > 0) {
      //this.messages.push(message);
      this.newchatmsg = message;
      this.sendChat();
    }
  }

  deleteChat(id){

    this.idChat = id;

    if(confirm("Are you sure you want to delete this chat?")) {
      this.saving = true;
      this._chatLogService.remove(this.token, this.idChat).subscribe(
        response => {
          if (response.status != 'success') {
            if (response.longmsg){
              this.showSwal('error', response.msg, response.longmsg);
            }else{
              this.showSwal('error', 'ERROR!', response.msg);
            }
          } else {
            this.showSwal('success', 'Chat removed!', 'The chat has been removed successfully');
            this.getChat();
          }
          this.saving = false;
         }, 
         error => { 
          console.log(<any>error);
          this.saving = false;
          this.showSwal('error');
        }
      );
    }

  }

  sendChat() {

    

    this.loading = true;

    let enviar;
    enviar = {
      'message': this.newchatmsg,
      'father_id': this.editCommentsIdx,
      'type': this.jsonChatLog.type,
      'ticketid': this.ticket.id
    };

    this._chatLogService.create(this.token, enviar).subscribe(
      response => {
        this.loading = false;
        if (response.status === 'success') {
          
          console.log(response.data);

          this.chats.push(response.data);

          this.myWebSocket.next({
            'notify': '1',
            'data': this.editCommentsIdx,
            'type': 'TICKETTAGGED',
            'token': this.token,
            'action': 'NEW', // NEW ó UPDATE ó DELETE
            'toDestiny': 'USERS',
            'toData': this.newchatmsg,
            'element': this.ticket.id,
            'texto': this.jsonChatLog.type
          });

          this.myWebSocket.asObservable().subscribe(
            msg => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log('message received: ' + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            err => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log('complete')
            // Called when connection is closed (for whatever reason)
          );

          this.newchatmsg = '';

        }

      },
      error => {
        console.log(<any>error);

      }
    );

  }

  cambiarLocacion(item) {
    if (!this.cambiandoLocaciones) {
      let json = {
        data: [
          {
            idweight: item.id,
            idlocation: item.internalLocation_id
          }
        ]
      }
      this._ticketsService.bulkLocations(json).subscribe(
        response => {
          console.log(response);
          let objeto = {
            numInmanifest: response.data.numInmanifest,
            numInsales: response.data.numInsales,
            numIntesting: response.data.numIntesting,
            numReceived: response.data.numReceived,
            num_processed: response.data.numProcessed,
            num_inmanifest_second: response.data.numInmanifestSecond,
            num_insales_second: response.data.numInsalesSecond,
            num_intesting_second: response.data.numIntestingSecond,
            num_received_second: response.data.numReceivedSecond,
            num_processed_second: response.data.numProcessedSecond,
            beenInmanifest: response.data.beenInmanifest,
            beenInsales: response.data.beenInsales,
            beenIntesting: response.data.beenIntesting,
            beenReceived: response.data.beenReceived
          }

          this.changeLocations.emit(objeto);
          this.cambiandoLocaciones = false;
        }
      );
    }
  }

  showSwal(type, title = '', message = '') {
    if (type === 'success') {
          swal.fire({
          
              title: title,
              text: message,
              buttonsStyling: false,
             
              customClass:{
    confirmButton: 'btn btn-success'
            },

          });

      } else if (type === 'error') {
        swal.fire({
       
          title: title,
          text: message,
          buttonsStyling: false,
          customClass:{
    confirmButton: 'btn btn-success'
            },

        });
      }
  }
}
